import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosConfiguracionProyectoComponent {
  idProyecto

  constructor (ViaticosCatalgosProyectoService) {
    this.ViaticosCatalgosProyectoService = ViaticosCatalgosProyectoService
  }

  $onInit () {
    this.promise = this.ViaticosCatalgosProyectoService.get(this.idProyecto)
      .then(({data}) => (this.proyecto = data))
  }
}

module.component('viaticosConfiguracionProyecto', {
  controller: ViaticosConfiguracionProyectoComponent,
  template,
  bindings: {
    idProyecto: '<',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/configuracion/proyecto/component.js